import React from 'react';

import Modal from 'components/modal';
import { IModalProps } from 'components/modal/types';

export const DetailsModalWrapper: React.FC<React.PropsWithChildren<IModalProps>> = ({
  children,
  ...props
}) => {
  return <Modal {...props}>{children}</Modal>;
};
